import React, { PureComponent } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import AppRoutePath from "./AppRoutePath";
import AppRouteData from "./AppRouteData";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Template from "../components/template/Template";
import SbgPublic from "../pages/sbg/SbgPublic";
import PrintNota from "../pages/finance/components/PrintNota/PrintNota";
import ExportPdf from "../pages/finance/components/ExportPdf/ExportPdf";
import ResetPassword from "../pages/ResetPassword";
import { onMessageListener } from "../components/template/firebaseInit";
import ReactNotificationComponent from "../components/template/notification/ReactNotification";

class AppRoute extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { show: false, notification: null };
  }
  render() {
    onMessageListener()
      .then((payload) => {
        this.setState({
          show: true,
          notification: {
            title: payload.notification.title,
            body: payload.notification.body,
          },
        });
      })
      .catch((err) => console.log("failed: ", err));
    return (
      <BrowserRouter>
        <Switch>
          <Route exact path={AppRoutePath.HOME} component={Home} />
          <Route path={AppRoutePath.LOGIN} component={Login} />
          <Route path={AppRoutePath.RESET_PASSWORD} component={ResetPassword} />
          <Route path={AppRoutePath.SBG_PUBLIC} component={SbgPublic} />
          <Route path={AppRoutePath.SBG_VALUATOR} component={SbgPublic} />
          <Route
            path={AppRoutePath.PRINT_NOTA_PAWN_TRANSACTION}
            component={PrintNota}
            exact
          />
          <Route
            path={AppRoutePath.PRINT_NOTA_CAPITAL_TRANSACTION}
            component={PrintNota}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_PAWN_TRANSACTION}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_CAPITAL_TRANSACTION}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_CASH_TRANSACTION}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_PAWN_REPORT}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_REFUND_REPORT}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_FAILED_REDEEM_REPORT}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_CUSTOMER}
            component={ExportPdf}
            exact
          />
          <Route
            path={AppRoutePath.EXPORT_PDF_PAWN}
            component={ExportPdf}
            exact
          />
          <Template>
            <Switch>
              {AppRouteData.map((value) => (
                <Route
                  path={value.path}
                  component={value.component}
                  key={value.path}
                  exact
                />
              ))}
            </Switch>
          </Template>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
        {this.state.show ? (
          <ReactNotificationComponent
            title={this.state.notification.title}
            body={this.state.notification.body}
          />
        ) : null}
      </BrowserRouter>
    );
  }
}

const NotFound = () => {
  return (
    <div className="d-flex justify-content-center">
      <h1>404 Not Found</h1>
    </div>
  );
};

export default AppRoute;
